<section class="hero-wrap hero-wrap-2" style="background-image: url('assets/images/background/bg_molcajete_2.jpg');" data-stellar-background-ratio="0.5">
    <div class="overlay"></div>
    <div class="container">
        <div class="row no-gutters slider-text align-items-end justify-content-center">
            <div class="col-md-9 text-center mb-4">
                <div class="bread">
                    <img src="assets/images/logo/logo_texto_2.png" style="width: 90%; height: auto;" alt="La Nopalera Restaurante">
                </div>
            </div>
        </div>
    </div>
</section>